var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.43247 5.50045V10.5577C3.43831 10.9275 3.58932 11.2802 3.8529 11.5396C4.11648 11.7991 4.47151 11.9445 4.84136 11.9445C5.21121 11.9445 5.56623 11.7991 5.82981 11.5396C6.0934 11.2802 6.2444 10.9275 6.25024 10.5577L6.25481 3.92897C6.25865 3.61289 6.1997 3.29919 6.0814 3.00606C5.96309 2.71293 5.78778 2.4462 5.56562 2.22133C5.34347 1.99646 5.07888 1.81792 4.78721 1.69607C4.49554 1.57422 4.18258 1.51147 3.86647 1.51147C3.55037 1.51147 3.23741 1.57422 2.94574 1.69607C2.65407 1.81792 2.38948 1.99646 2.16732 2.22133C1.94517 2.4462 1.76985 2.71293 1.65155 3.00606C1.53324 3.29919 1.4743 3.61289 1.47813 3.92897V10.6023C1.47169 11.0473 1.55378 11.4891 1.71962 11.9021C1.88545 12.3151 2.13173 12.691 2.44413 13.008C2.75654 13.3249 3.12884 13.5766 3.53938 13.7484C3.94992 13.9202 4.39052 14.0087 4.83556 14.0087C5.28059 14.0087 5.72119 13.9202 6.13173 13.7484C6.54228 13.5766 6.91457 13.3249 7.22698 13.008C7.53938 12.691 7.78566 12.3151 7.9515 11.9021C8.11733 11.4891 8.19942 11.0473 8.19298 10.6023V4.36631",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.81fac57d0a94372738b5f6562902dc6c.svg";
export { ForwardRef as ReactComponent };